(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ClusterService', ClusterService)

    /** @ngInject */
    function ClusterService(HttpService) {
        const ClusterService = {
            get: get,
            getAll: getAll,
            getByParameters: getByParameters,
            post: post,
            put: put,
            deleteCluster: deleteCluster
        }

        return ClusterService;

        function get(groupId) {
            return HttpService.get(`/clusters/${groupId}`);
        }

        function getAll() {
            return HttpService.get('/clusters/all');
        }

        function getByParameters(params) {
            return HttpService.get('/clusters', {
                params
            });
        }

        function post(groupData) {
            return HttpService.post('/clusters', groupData);
        }

        function put(groupData) {
            return HttpService.put('/clusters', groupData);
        }

        function deleteCluster(groupId) {
            return HttpService.delete(`/clusters/${groupId}`);
        }
    }
}());